import axios from 'axios'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import Modal from 'react-modal'
import { EXAM, PATIENT, TYPE_EXAM } from '../services/routes'
import { Footer } from '../components/Footer'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const NewExam = () => {

    const { id } = useParams()

    const token = localStorage.getItem('token')

    const [patient, setPatient] = useState('')
    const [patientName, setPatientName] = useState('')
    const [patientData, setPatientData] = useState()
    const [searchPatient, setSearchPatient] = useState('')
    const [searchTypeExam, setSearchTypeExam] = useState('')
    const [typeExamName, setTypeExamName] = useState('')
    const [type, setType] = useState('')
    const [date, setDate] = useState('')
    const [patients, setPatients] = useState([])
    const [typeExam, setTypeExam] = useState([])
    const [loading, setLoading] = useState(true)

    const [modalIsOpen, setIsOpen] = useState(false);
    const [showPostModal, setShowPostModal] = useState(false)
    const [showPostModalExam, setShowPostModalExam] = useState(false)


    const formatDate = item => {
        let date = new Date(item)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()

        return `${year}-${month}-${day}`
    }



    const getPatient = async () => {
        await axios.get(`${PATIENT.GETALL}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log(json.data.patient)
                setPatients(json.data.patient)
                setLoading(false)
            })
            .catch(err => {
                console.error(err)
            })
    }

    const getExamId = async () => {
        let data

        if (id) {
            await axios.get(EXAM.GET.replace(/:id/gi, id), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    data = res.data.exam
                    console.log('examId ', data)
                    setPatient(data.patient)
                    getPatientId(data.patient)
                    setDate(formatDate(data.date))
                    setType(data.type)
                    getTypeExamId(data.type)
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    const getTypeExam = async () => {

        await axios.get(`${TYPE_EXAM.GETALL}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log('typeExam ', json.data)
                setTypeExam(json.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const getPatientId = async (patientId) => {
        if (patientId) {

            await axios.get(PATIENT.GET.replace(/:id/gi, patientId), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    console.log('patientId ', res.data.patient)
                    setPatientData(res.data.patient)
                    setPatientName(`${res.data.patient.name} ${res.data.patient.lastname}`)
                })
        }
    }

    const getTypeExamId = async (typeExamId) => {
        let data
        if (typeExamId) {

            await axios.get(TYPE_EXAM.GET.replace(/:id/gi, typeExamId), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    data = res.data.typeExam
                    console.log('typeExamId ', res.data.typeExam)
                    setTypeExamName(data.title)
                    
                    // setPatientData(res.data.patient)
                    // setPatientName(`${res.data.patient.name} ${res.data.patient.lastname}`)
                })
        }
    }

    const togglePostModal = () => {
        setIsOpen(!modalIsOpen);
        setShowPostModal(!showPostModal)
    }

    const togglePostModalTypeExam = () => {
        setIsOpen(!modalIsOpen);
        setShowPostModalExam(!showPostModalExam)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (id) {
            await axios.put(EXAM.UPDATE.replace(/:id/gi, id), {
                patient,
                date,
                type
            }, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    console.log(res)
                    toast.success('Exame atualizado')
                })
                .catch(err => {
                    console.log(err)
                    toast.error('Erro ao atualizar')
                })
            return;
        }

        axios.post(`${EXAM.CREATE}`, {
            patient,
            type,
            date
        }, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log(json)
                toast.success('Exame registrado!')
            })
            .catch(err => {
                console.error(err)
                toast.error('Problema ao registrar.')
            })
    }

    useEffect(() => {

        getExamId()
        getTypeExam()
        getPatient()
    }, [searchPatient])

    return (
        <>
            <Helmet>
                <title>Novo exame - Coluço System</title>
            </Helmet>
            <div id="wrapper">

                {showPostModal && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Seleção de paciente"
                >
                    <input
                        className="form-control mb-2"
                        list="dataListPatient"
                        onChange={e => setSearchPatient(e.target.value)}
                        placeholder="Digite o nome ou CPF para pesquisar"
                    />
                    {patients.filter(item => {
                        if (searchPatient === '') {
                            return ''
                        } else if (item.name.toLowerCase().includes(searchPatient.toLowerCase()) || item.cpf.includes(searchPatient.toLowerCase())) {
                            return item
                        }
                    }).map((item, index) => {
                        return (
                            <div className="d-grid gap-2">
                                <button key={index} type="button" onClick={() => {
                                    setPatient(item._id)
                                    setPatientName(`${item.name} ${item.lastname}`)
                                    togglePostModal()
                                    setSearchPatient('')
                                }} className="btn btn-light">{item.name} {item.lastname} <br /> {item.cpf}</button>
                            </div>
                        )
                    })}

                </Modal>}

                {showPostModalExam && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Seleção de exame"
                >
                    <input
                        className="form-control mb-2"
                        list="dataListPatient"
                        onChange={e => setSearchTypeExam(e.target.value)}
                        placeholder="Digite o nome do tipo de exame"
                    />
                    {typeExam.filter(item => {
                        if (searchTypeExam === '') {
                            return ''
                        } else if (item.title.toLowerCase().includes(searchTypeExam.toLowerCase())) {
                            return item
                        }
                    }).map((item, index) => {
                        return (
                            <div className="d-grid gap-2">
                                <button key={index} type="button" onClick={() => {
                                    setType(item._id)
                                    setTypeExamName(`${item.title}`)
                                    togglePostModalTypeExam()
                                    setSearchTypeExam('')
                                }} className="btn btn-light">{item.title}</button>
                            </div>
                        )
                    })}

                </Modal>}

                <Header active="newExam" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <h1 className="h3 mb-2 text-gray-800">Novo Exame</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Adicionar um novo exame</h6>
                                </div>
                                <div className="card-body">
                                    {loading ?
                                        <span>Carregando</span>
                                        :
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-row">
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label className="form-label">Paciente *</label> <br />
                                                                <button type="button" className="btn btn-outline-secondary" onClick={() => togglePostModal()}>{patient !== '' ? patientName : 'Selecione um paciente'}</button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Tipo de exame *</label> <br />
                                                                <button type="button" className="btn btn-outline-secondary" onClick={() => togglePostModalTypeExam()}>{typeExamName !== '' ? typeExamName : 'Selecione um tipo de exame'}</button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Data *</label>
                                                                <input type="date" value={date} onChange={e => setDate(e.target.value)} className="form-control" placeholder="Data" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center mt-3">
                                                <button type="submit" className="btn btn-primary">Cadastrar</button>
                                            </div>
                                        </form>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </>
    )
}

export default NewExam
